import { BOX_TYPE, LAYOUT_TYPE } from './domain';

const theme = IS_SHOPIFY_ENV
  ? Shopify && Shopify.theme
    ? Shopify.theme.name.trim().replace(new RegExp(' ', 'g'), '_')
    : 'upsell-theme-notfound'
  : '';

export const Element_Ids = {
  price: 'upsell-price',
  varaintSelector: 'upsell-variant-selector-',
  addOnItemContainer: 'upsell-addon-'
};
export const TOKENS = {
  headerText: '{{headerText}}',
  addOns: '{{addOns}}',
  img: '{{img}}',
  title: '{{title}}',
  price: '{{price}}',
  compareAtPrice: '{{compareAtPrice}}',
  addOnSlug: '{{addOnSlug}}',
  id: '{{id}}',
  addToCartText: '{{addToCartText}}',
  removeFromCartText: '{{addedToCart}}',
  seeDetailsText: '{{seeDetailsText}}',
  qtyLabel: '{{qtyLabel}}',
  addOnProductHandle: '{{addOnProductHandle}}',
  description: '{{description}}'
};

export const STYLE_TOKENS = {
  fontColor: '{{fontColor}}',
  fontSize: '{{fontSize}}',
  borderWidth: '{{borderWidth}}',
  borderColor: '{{borderColor}}',
  header: '{{headerStyle}}',
  fontWeight: '{{fontWeight}}',
  customCss: '{{customCss}}',
  headerColor: '{{headerColor}}',
  headerFontSize: '{{headerFontSize}}',
  imageHeight: '{{imageHeight}}',
  imageWidth: '{{imageWidth}}',
  buttonHeight: '{{buttonHeight}}',
  buttonWidth: '{{buttonWidth}}',
  buttonFontSize: '{{buttonFontSize}}',
  buttonPaddingLeft: '{{buttonPaddingLeft}}',
  buttonPaddingTop: '{{buttonPaddingTop}}',
  buttonPaddingRight: '{{buttonPaddingRight}}',
  buttonPaddingBottom: '{{buttonPaddingBottom}}',
  flexDisplay: '{{flexDisplay}}',
  addOnBoxDisplay: '{{addOnBoxDisplay}}',
  addOnBoxWidth: '{{addOnBoxWidth}}',
  addOnBoxHeight: ' {{addOnBoxHeight}}',
  flexWrap: '{{flexWrap}}',
  flexGrow: '{{flexGrow}}',
  containerWidth: '{{containerWidth}}',
  containerHeight: '{{containerHeight}}',
  descriptionFontSize: '{{descriptionFontSize}}',
  descriptionFontColor: '{{descriptionFontColor}}'
};

export const CssClasses = {
  hidden: 'upsell-hidden',
  invisible: 'upsell-invisible',
  container: 'upsell-container',
  addOnContainer: 'upsell-addon-container',
  inline: 'upsell-inline',
  placeholder: 'upsell-addon-placeholder',
  col1: 'upsell-addonbox-col1',
  col2: 'upsell-addonbox-col2',
  col3: 'upsell-addonbox-col3',
  title: 'upsell-addon-title',
  placeholderLine1: 'placeholder-line1',
  placeholderLine2: 'placeholder-line2',
  animatedBackground: 'animated-background',
  cartButton: 'upsell-addToCart',
  image: 'upsell-addon-img',
  compareAtPrice: 'upsell-compare-at-price',
  hasCompareAtPrice: 'upsell-has-compare-at-price',
  upsellPriceValue: 'upsell-price-value',
  variantDropdown: 'upsell-variant-options',
  header: 'upsell-header',
  addonBox: 'upsell-addonbox',
  defaultAddOnBox: 'upsell-defaultbox',
  imageTop: 'upsell-img-top-addonbox',
  imageLeft: 'upsell-img-left-addonbox',
  qtyWrapper: 'upsell-qty-wrapper',
  qtyBox: 'upsell-qtyBox',
  flexLayout: 'upsell-flex-layout',
  sliderLayout: 'upsell-slider-layout',
  qtyBoxInput: 'upsell-qty-input',
  upsellPrice: 'upsell-price',
  defaultLayout: 'upsell-default',
  cartPageContainer: 'upsell-cartpage-container',
  description: 'upsell-description'
};

export const OPTIONS_TOKENS = {
  plusSign: '{{plus}}',
  seeDetails: '{{seeDetails}}',
  titleSnippet: '{{titleSnippet}}',
  addToCartInput: '{{addToCartInput}}',
  imageClassName: '{{imageClassName}}',
  variantDropdown: '{{variantDropdown}}',
  hasCompareAtPriceClassName: '{{hasCompareAtPriceClassName}}'
};
export const FLEX_DISPLAY = 'display:flex;flex-wrap: wrap;';

export function productPageContainer(layoutType) {
  return container('upsell-productpage', '', layoutType);
}

export function cartPageContainer(layoutType) {
  return container('upsell-cartpage', CssClasses.cartPageContainer, layoutType);
}

export function placeholder() {
  return `<div class="${CssClasses.addonBox} ${CssClasses.placeholder}">
              <div class="${CssClasses.col1} ${CssClasses.animatedBackground}">
              </div>
              <div class="${CssClasses.col2}">
                  <div class="${CssClasses.placeholderLine1} ${CssClasses.animatedBackground}"></div>
                  <div class="${CssClasses.placeholderLine2} ${CssClasses.animatedBackground}"></div>
              </div>
          </div>`;
}

export function addOn(boxType) {
  let boxClass = CssClasses.defaultAddOnBox;
  if (boxType === BOX_TYPE.ImageTop) {
    boxClass = CssClasses.imageTop;
  } else if (boxType === BOX_TYPE.ImageLeft) {
    return imageLeftAddon();
  }
  const descHtml = `<div class=${CssClasses.description}>${TOKENS.description}</div>`;
  return `<div class="${CssClasses.addonBox}">
            <div class="${boxClass}" id="${Element_Ids.addOnItemContainer}${TOKENS.addOnProductHandle}">
                <div class="${CssClasses.col1}">
                    <img src="${TOKENS.img}" class="${OPTIONS_TOKENS.imageClassName}">
                </div>
                <div class="${CssClasses.col2}">
                    <span class="product-single__title upsell-font-color ${CssClasses.title}">${OPTIONS_TOKENS.titleSnippet}</span>
                    <br/>
                    ${OPTIONS_TOKENS.variantDropdown}
                    <a href="${TOKENS.addOnSlug}" target="_blank" class="upsell-addon-details ${OPTIONS_TOKENS.seeDetails}">${TOKENS.seeDetailsText}</a>
                    
                </div>
                <div class="${CssClasses.col3}">
                      ${OPTIONS_TOKENS.addToCartInput}
                </div>
            </div>
            ${descHtml}
          </div>`;
}

function imageLeftAddon() {
  return `<div class="${CssClasses.addonBox} ${CssClasses.imageLeft}" id="${Element_Ids.addOnItemContainer}${TOKENS.addOnProductHandle}">
              <div class="${CssClasses.col1}">
                  <span class="product-single__title upsell-font-color ${CssClasses.title}">${OPTIONS_TOKENS.titleSnippet}</span>
              </div>
              <div class="${CssClasses.col2}">
                    <div>
                      <img src="${TOKENS.img}" class="${OPTIONS_TOKENS.imageClassName}">                    
                    </div>
                    <div class="${CssClasses.col3}">
                      ${OPTIONS_TOKENS.variantDropdown}
                      <a href="${TOKENS.addOnSlug}" target="_blank" class="upsell-addon-details ${OPTIONS_TOKENS.seeDetails}">${TOKENS.seeDetailsText}</a>                  
                      ${OPTIONS_TOKENS.addToCartInput}                     
                    </div>                
              </div>
              <div class=${CssClasses.description}>
                ${TOKENS.description}
              </div>
          </div>`;
}

export function button(original, isGroupedVariant, productHandle) {
  const className = original.className;
  const style = original.style ? original.style.cssText : '' || '';
  return `<div class="${CssClasses.upsellPrice}">${priceHtml()}</span>
            <button class="${className} ${CssClasses.cartButton}"
              onclick="upsell.addToCart('${TOKENS.id}', '${
    TOKENS.addToCartText
  }', '${
    TOKENS.removeFromCartText
  }', this, ${isGroupedVariant}, '${productHandle}')" 
              type="button"
              style="${style}">
              ${TOKENS.addToCartText}
            </button>
          </div>`;
}

export function checkbox(isGroupedVariant, productHandle) {
  return `<label class="${CssClasses.upsellPrice}">${priceHtml()}</span>
            <input type="checkbox"  onclick="upsell.toggleAddonSelection('${
              TOKENS.id
            }', this, ${isGroupedVariant}, '${productHandle}')"/>            
          </label>`;
}
export function qtyBox(isGroupedVariant, productHandle) {
  return `<div class="${CssClasses.qtyBox}">
        <div class="${CssClasses.upsellPrice}">${priceHtml()}</div>
        <div class="${CssClasses.qtyWrapper}">
          <div class="upsell-qty-label">${TOKENS.qtyLabel}</div>   
          <div class="${
            CssClasses.qtyBoxInput
          }"><input type="number" min="0" onchange="upsell.captureQty('${
    TOKENS.id
  }', this, ${isGroupedVariant}, '${productHandle}')" /> </div>
        </div>
  </div>`;
}

export function qtyDropdown(isGroupedVariant, productHandle, options) {
  let optionsHtml = '`<option value=""></option>';
  for (let i = 0; i < options.length; i++) {
    optionsHtml += `<option value="${options[i]}">${options[i]}</option>`;
  }
  return `<div class="upsell-qtyBox">
        <div class="${CssClasses.upsellPrice}">${priceHtml()}</div>
        <div class="${CssClasses.qtyWrapper}">
          <div class="upsell-qty-label">${TOKENS.qtyLabel}</div>        
          <div class="${CssClasses.qtyBoxInput}">            
            <select class="upsell-qty-dropdown" onchange="upsell.captureQty('${
              TOKENS.id
            }', this, ${isGroupedVariant}, '${productHandle}')" >${optionsHtml}</select>
          </div>
        </div>
  </div>`;
}

export function variantDropdown(productHandle, variantOptions, label) {
  if (variantOptions && variantOptions.length > 0) {
    let options = '';
    const optionsLabel = label ? `${label}:` : '';
    for (let i = 0; i < variantOptions.length; i++) {
      options += `<option value=${variantOptions[i].id}>${variantOptions[i].title}</option>`;
    }
    return `<div class="${CssClasses.variantDropdown}">
                <label>${optionsLabel}</label>
                <select id="${Element_Ids.varaintSelector}${productHandle}" 
                        onchange="upsell.changeVariant('${productHandle}', 
                                                       '${encodeURIComponent(
                                                         JSON.stringify(
                                                           variantOptions
                                                         )
                                                       )}',
                                                       this.value)">
                        ${options}
                </select>
            </div>`;
  }
  return '';
}
export function styles() {
  return `<style type="text/css"> 
        .${CssClasses.container} {margin-top:10px;margin-bottom:10px;}
        .${CssClasses.invisible}{visibility:hidden;max-height:0px;} 
        .${CssClasses.hidden}{display:none;}
        .${CssClasses.inline}{display:inline;}
        .${CssClasses.header} {
            ${STYLE_TOKENS.headerFontSize}
            ${STYLE_TOKENS.headerColor}
        }
        .${CssClasses.description} {
          ${STYLE_TOKENS.descriptionFontSize}
          ${STYLE_TOKENS.descriptionFontColor}
          text-align:initial;
        }
        .${CssClasses.addonBox} {
          border:${STYLE_TOKENS.borderWidth} solid ${STYLE_TOKENS.borderColor};
          border-radius:4px;         
          padding:6px;   
          box-sizing: border-box; 
          ${STYLE_TOKENS.addOnBoxWidth}
          ${STYLE_TOKENS.addOnBoxHeight}
        }

        .${CssClasses.defaultLayout}  .${CssClasses.addonBox} {
          margin-bottom:12px;
        }
        .${CssClasses.defaultAddOnBox} {
          display:flex;      
        }

        .${CssClasses.qtyWrapper} {
           display:flex;      
           justify-content: center;
        }
       
        .${CssClasses.placeholder} .${CssClasses.col2},
        .${CssClasses.defaultAddOnBox} .${CssClasses.col2}{
            margin-left:4px;
        }

        .${CssClasses.defaultAddOnBox}  .${CssClasses.col3}{
           margin-left:auto;
           text-align:center;
           padding-left:4px;
        }
        
        .${CssClasses.flexLayout}{
            display:flex;
            flex-wrap:${STYLE_TOKENS.flexWrap};
        }
        
        .${CssClasses.flexLayout} .${CssClasses.addonBox} {
            ${STYLE_TOKENS.flexGrow}
            margin-right:8px;
            margin-bottom:10px;
         }
         .${CssClasses.imageTop} .${CssClasses.col2} {
            text-align:center; 
         }
        
        
        .${CssClasses.imageLeft} .${CssClasses.upsellPrice},
        .${CssClasses.imageTop} .${CssClasses.upsellPrice} {
            text-align:center;
            width:100%;
         }
         .${CssClasses.imageLeft} label.${CssClasses.upsellPrice},
         .${CssClasses.imageTop} label.${CssClasses.upsellPrice} {
            display:block;
         }
         .${CssClasses.imageTop} .${CssClasses.col1}{
            text-align:center;          
         }

         .${CssClasses.imageLeft} .${CssClasses.cartButton},
         .${CssClasses.imageTop} .${CssClasses.cartButton} {
            display:block;
         }

         .${CssClasses.imageLeft} .${CssClasses.col2}{
           display:flex;
         }
         .${CssClasses.imageLeft} .${CssClasses.col3} {
            margin-left:8px;
         }

         .Brooklyn .${CssClasses.sliderLayout}{
            height:250px;
            width:400px;
         }

         
         .${CssClasses.addOnContainer}{
            ${STYLE_TOKENS.containerWidth}
            ${STYLE_TOKENS.containerHeight}
         }

         .${CssClasses.sliderLayout} .${CssClasses.addonBox}{
            margin-right:8px;
         }
         
         .${CssClasses.sliderLayout} .${CssClasses.imageTop} .${CssClasses.col3} {
            position:absolute;
            bottom:6px;
            left:0;
            right:0;
            width:100%;
            padding-left:5px;
            padding-right:3px;
         }
        .${CssClasses.addonBox} img{
          ${STYLE_TOKENS.imageHeight}
          ${STYLE_TOKENS.imageWidth}
        }
        .upsell-addon-title{
          font-weight:${STYLE_TOKENS.fontWeight};
          ${STYLE_TOKENS.fontColor}
          ${STYLE_TOKENS.fontSize}
        }
        .upsell-qty-label{
          margin-right:1px;
        }
        .upsell-qty-label,
        .${CssClasses.upsellPrice},
        .upsell-addon-details{
          font-size:0.9375em;
          font-weight:normal;
        }      
        .${CssClasses.upsellPrice} {
          white-space: nowrap;
        }
        
        .${CssClasses.upsellPrice} input[type="checkbox"]{
           position:relative;
           top:1px;
           min-height:initial;
        }
        label.${CssClasses.upsellPrice}{
          white-space:nowrap;
        }

        .${CssClasses.cartButton}{
          height: ${STYLE_TOKENS.buttonHeight}px!important;
          ${STYLE_TOKENS.buttonWidth}
          padding-left:${STYLE_TOKENS.buttonPaddingLeft}px!important;
          padding-top:${STYLE_TOKENS.buttonPaddingTop}px!important;
          padding-right:${STYLE_TOKENS.buttonPaddingRight}px!important;
          padding-bottom:${STYLE_TOKENS.buttonPaddingBottom}px!important;
          font-size:${STYLE_TOKENS.buttonFontSize}!important;
        }
        .upsell-cartpage {            
            display:flex;
            flex-wrap: wrap;
            justify-content: center;            
        }
       
        .upsell-cartpage .${CssClasses.addonBox}{
          margin-left: 12px;
          ${STYLE_TOKENS.addOnBoxWidth}
          ${STYLE_TOKENS.addOnBoxHeight}      
        }

        .${CssClasses.cartPageContainer} h4 {
          text-align: center;
        }

        .${CssClasses.cartPageContainer} .${CssClasses.placeholder},
        .${CssClasses.cartPageContainer} .${CssClasses.addOnContainer} {
          margin:auto;
        }

        .upsell-cartpage .${CssClasses.upsellPrice} {
          white-space: initial;
        }
        
        @keyframes placeHolderShimmer{
          0%{
              background-position: -468px 0
          }
          100%{
              background-position: 468px 0
          }
        }
      
        .${CssClasses.animatedBackground} {
            animation-duration: 1s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: placeHolderShimmer;
            animation-timing-function: linear;
            background: #f6f7f8;
            background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
            background-size: 800px 104px;
            height: 96px;
            position: relative;
        }
        .${CssClasses.addonBox}.${CssClasses.placeholder} {
          height:80px;
          display:flex;
          width:400px;
          flex-grow:initial;
        }

        .${CssClasses.placeholder} .${CssClasses.col1}{
            height:60px;
            width:100px;
        }
        
        .${CssClasses.col2} .${CssClasses.placeholderLine1} {
          height:10px;
          width:200px;
        }

        .${CssClasses.col2} .${CssClasses.placeholderLine2} {
          height:10px;
          width:100px;
          margin-top:5px;
        }

        .Brooklyn .${CssClasses.title}{
          font-size:1em!important
        }
        .${CssClasses.compareAtPrice} {
          text-decoration: line-through;
          display:inline-block;
          padding-right:2px;

        }
        
        .${CssClasses.qtyBox} {
          display:flex; 
        }

        .${CssClasses.imageLeft} .${CssClasses.qtyBox},
        .${CssClasses.imageTop} .${CssClasses.qtyBox} {
          display:block;        
        }
        
        .${CssClasses.upsellPrice}{
           margin-right:3px;
        }
        
        .${CssClasses.qtyBoxInput} {
          width:50px;          
        }
       
        .${CssClasses.qtyBoxInput} input {
           padding:5px 0px 5px 5px;
           height:initial;
           min-height:initial;
        }
        .${CssClasses.variantDropdown} {
          display:flex;
        }
        .${CssClasses.imageTop} .${CssClasses.variantDropdown} {
          flex-wrap:wrap;
        }
        .${CssClasses.variantDropdown} label {
          padding-right:3px;
        }
        @media only screen and (max-width: 479px) {
          .Venture .${CssClasses.defaultAddOnBox} .${CssClasses.qtyWrapper},
          .Debut .${CssClasses.defaultAddOnBox} .${CssClasses.qtyWrapper} {
             flex-wrap:wrap;
          }    
          .Venture .${CssClasses.defaultAddOnBox} .${CssClasses.qtyWrapper} div,
          .Debut .${CssClasses.defaultAddOnBox} .${CssClasses.qtyWrapper} div {
            flex:1;
          }

          .${CssClasses.flexLayout} {
            flex-wrap:wrap;
          }
        }
        ${STYLE_TOKENS.customCss}
       
    </style>`;
}

function priceHtml() {
  return `${OPTIONS_TOKENS.plusSign}<span class="${CssClasses.compareAtPrice}">${TOKENS.compareAtPrice}</span><span id="${Element_Ids.price}" class="${OPTIONS_TOKENS.hasCompareAtPriceClassName}">${TOKENS.price}</span>`;
}
function container(pageTypeClass, containerType, layoutType) {
  let layoutClass = CssClasses.defaultLayout;
  if (layoutType === LAYOUT_TYPE.Flex) {
    layoutClass = CssClasses.flexLayout;
  } else if (layoutType === LAYOUT_TYPE.Slider) {
    layoutClass = CssClasses.sliderLayout;
  }
  return `<div class="${CssClasses.container} ${containerType} ${theme}">
    <h4 class="upsell-font-color ${CssClasses.header} ${STYLE_TOKENS.header}">${
    TOKENS.headerText
  }</h4>     
      <div class="${CssClasses.addOnContainer} ${layoutClass}${
    layoutType === LAYOUT_TYPE.Default ? ` ${pageTypeClass}` : ''
  }">
        ${TOKENS.addOns}      
      </div>     
  </div>`;
}
